import { render } from "./BattlesGameHeaderBoxes.vue?vue&type=template&id=667f6c6e&scoped=true"
import script from "./BattlesGameHeaderBoxes.vue?vue&type=script&lang=js"
export * from "./BattlesGameHeaderBoxes.vue?vue&type=script&lang=js"

import "./BattlesGameHeaderBoxes.vue?vue&type=style&index=0&id=667f6c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667f6c6e"]])

export default __exports__